import { render, staticRenderFns } from "./ItemBuilderCard.vue?vue&type=template&id=96a23710&"
import script from "./ItemBuilderCard.vue?vue&type=script&lang=ts&"
export * from "./ItemBuilderCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports